import { Box, Typography } from '@mui/material';
import React, { ReactElement, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { UploadPacketReworkService } from 'services/UploadPacketReworkService';

import { HeadTag } from 'shared/components';

const FinishUploadReworkPage = (): ReactElement => {
    const location = useLocation();
    const defaultState = location.state;
    const { packetId, token } = useParams();

    const [msg, setMsg] = useState<string>('');
    React.useLayoutEffect(() => {
        if (packetId && token) {
            if (
                defaultState === null ||
                (defaultState && typeof defaultState.msg === 'undefined')
            ) {
                UploadPacketReworkService.getReworkPackets({ packetId, token })
                    .then(() => {
                        // navigation(`/upload-rework/${packetId}/${token}`);
                    })
                    .catch((error) => {
                        setMsg(error.response.data.msg);
                    });
            } else {
                setMsg(defaultState.msg);
            }
        }
    }, [defaultState, packetId, token]);
    /**
     * Handle onlick of logo in footer area
     */
    const handleLogoFooterOnClick = React.useCallback(() => {
        // navigation('/manage-cross-checks');
    }, []);
    return (
        <>
            <HeadTag title="Upload Rework Expirity" />
            <Box
                className="finish-wrapper"
                alignItems="flex-start"
                justifyContent="space-between"
            >
                <Box
                    className="wrapper-text"
                    display="flex"
                    alignItems="center"
                    flexGrow="1"
                    width="100%"
                    justifyContent="center"
                >
                    <Typography>{msg}</Typography>
                </Box>
                <Box className="menu-footer" p={14}>
                    <img
                        className="app-logo"
                        src="/images/brand/logo-uow-dark.png"
                        onClick={handleLogoFooterOnClick}
                        alt="UOW logo"
                        width={200}
                        height={188}
                    />
                </Box>
            </Box>
        </>
    );
};

export default FinishUploadReworkPage;
